import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../features/UserActions";
import styled, { keyframes } from "styled-components";
import {
  BsFillExclamationTriangleFill,
  BsFillEmojiSmileFill,
} from "react-icons/bs";

export default function MessageReminder() {
  const reminder = useSelector((state) => state.userAction.reminderStatus);
  const scrollTop = useSelector((state) => state.scrollTrack.value.scTop);
  const dispatch = useDispatch();

  /*--------------------------------------------------------------------*/
  useEffect(() => {
    if (reminder.show) {
      setTimeout(function () {
        dispatch(setReminder({ show: false, message: "..." }));
      }, 3000);
    }
    // console.log(scrollTop);
  }, [reminder]);

  /*--------------------------------------------------------------------*/
  const messageStyle = () => {
    if (reminder.type) {
      switch (reminder.type) {
        case "success":
          return (
            <AlertBox>
              <SuccessIcon />
              <br />
              <LabelMessage>{reminder.message}</LabelMessage>
            </AlertBox>
          );
        case "error":
          return (
            <AlertBox>
              <AlertIcon />
              <br />
              <LabelMessage>{reminder.message}</LabelMessage>
            </AlertBox>
          );
        default:
          return (
            <AlertBox>
              <SuccessIcon />
              <br />
              <LabelMessage>{reminder.message}</LabelMessage>
            </AlertBox>
          );
      }
    }
  };

  const getBackground = () => {
    if (reminder.type) {
      switch (reminder.type) {
        case "success":
          return { backgroundColor: "green", color: "white" };
        case "error":
          return { backgroundColor: "red", color: "white" };
        default:
          return { backgroundColor: "#b3440d" };
      }
    }
  };
  /*--------------------------------------------------------------------*/

  return (
    <MainBox top={scrollTop} {...reminder} style={getBackground()}>
      {messageStyle()}
      {/* <WaterDrop top={scrollTop} style={getBackground()} /> */}
    </MainBox>
  );
}
/*--------------------------------------------------------------------*/
const WaterDrop = styled.div`
  position: absolute;
  //bottom: -${(p) => p.top}px;
  top: -${(p) => p.top}px;
  right: 30px;
  /* margin-bottom: -10px; */
  /* bottom: -800px; */
  width: 20px;
  height: 20px;
  transform: rotate(40deg);
  background-color: #b3440d;
  align-items: center;
  /* border-radius: 0 0 0 50% ;  */
`;

const anim = keyframes`
     0% {opacity:0}
     50%{opacity:0.4}
     70%{opacity:0.8}
     100%{opacity:0.7}
`;

const MainBox = styled.div`
  width: 400px;
  height: 200px;
  z-index: 5000;
  background-color: #b3440d;
  position: absolute;
  color: white;
  top: auto;
  left: auto;
  /* bottom: 0px; */
  bottom: -${(p) => p.top}px;
  right: 20px;
  /* margin-bottom:-300px;   */
  padding: 20px;
  opacity: 0.9;
  border-radius: 10px 10px 10px 10px;
  box-shadow: #1a1919 0px 14px 28px;

  ${(props) => {
    if (props.show) {
      return ` 
            visibility: visible;             
            margin-bottom: 50px;     
            opacity:1;          
            transition: 0.3s ease-in;    
          `;
    } else {
      return ` 
            visibility: hidden;
            margin-bottom: 20px; 
            opacity:0; 
            transition: 0.7s ease-out;    
          `;
    }
  }}
`;

const SuccessIcon = styled(BsFillEmojiSmileFill)`
  width: 50px;
  height: 50px;
  color: white;
  margin-right: 5px;
`;

const AlertIcon = styled(BsFillExclamationTriangleFill)`
  width: 50px;
  height: 50px;
  color: white;
  margin-right: 5px;
`;

const AlertBox = styled.div`
  flex: 1;
  text-align: center;
`;

const LabelMessage = styled.div`
  margin-top: 10px;
`;
